import React from 'react';
import { Badge } from '../ui/badge';

interface CallScoreBadgeProps {
  score?: number | null;
  threshold?: number;
  className?: string;
}

const CallScoreBadge: React.FC<CallScoreBadgeProps> = ({ 
  score, 
  threshold = 0.85, 
  className = '' 
}) => {
  if (score === null || score === undefined || isNaN(score)) {
    return <Badge variant={'outline'}>Excused</Badge>;
  }

  const isAboveThreshold = score >= threshold;
  const badgeClassName = isAboveThreshold
    ? `bg-green-100 text-green-800 border-green-200 ${className}`
    : `bg-yellow-100 text-yellow-800 border-yellow-200 ${className}`;


  return (
    <Badge variant={'outline'} className={badgeClassName}>
      {isAboveThreshold ? `PASS (${score.toFixed(2)})` : `FAIL (${score.toFixed(2)})`}
    </Badge>
  );
};

export default CallScoreBadge;